import { defineStore, acceptHMRUpdate } from 'pinia'
import { type CanxNotification, toNotification, type NotificationAPIResponse } from '../utils/notifications'

export const useNotificationStore = defineStore('notifications', () => {
  const logger = useCanxLogger()
  const userNotifications = ref<CanxNotification[]>([])

  const fetchNotificationsByUserId = async () => {
    const { data } = await $apiFetch<{ notifications: NotificationAPIResponse[] }>(`notifications`, `/api/notifications?limit=200`)

    const mappedData = data.value!.notifications.map(n => toNotification(n, logger))
    userNotifications.value = mappedData
  }

  const actionOnNotification = async (id: number[]) => {
    const body = {
      mun_ids: id,
      clearAll: id.length === 0,
    }

    const { data } = await $apiFetch<NegotiationAPIResponse>(`not_${JSON.stringify(id)}`, `/api/notifications/read/`, { method: 'PUT', body: body })
    if (data.value) {
      return true
    }
  }

  return { userNotifications, fetchNotificationsByUserId, actionOnNotification }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useNotificationStore, import.meta.hot))
}
